import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    finger: "",
    searchFlag: false,
    loginFlag: false,
    bgSoundFlag: false,
    isPlayBgSound: false,
    registerFlag: false,
    forgetFlag: false,
    emailFlag: false,
    drawer: false,
    loginUrl: "",
    userId: null,
    avatar: null,
    nickname: null,
    intro: null,
    webSite: null,
    loginType: null,
    email: null,
    token: null,
    dialogFormVisible: false,
    articleLikeSet: [],
    commentLikeSet: [],
    isSimplify: false,
    blogInfo: {
      webSite: {
        authorAvatar: null,
        authorInfo: null,
        touristAvatar: null,
        loginTypeList: "",
        bulletin: null,
        aboutMe: null,
        logo: null,
        github: null,
        gitee: null,
        qqNumber: null,
        recordNum: null,
        author: null,
        aliPay: null,
        weixinPay: null,
        keyword: null,
        name: null,
        summary: null,
        webUrl: null,
        showList: "",
      },
      count: {
        articleCount: null,
        categoryCount: null,
        tagCount: null,
        viewsCount: null,
      },
      pageList: [
        {
          pageCover: null,
          pageLabel: null,
        },
      ],
    },
    skillInfo: {
      level: null,
      points: null,
      chatgptMaxQuotaLevel: null,
      chatgptVipLevel: null,
      aiArtMaxQuotaLevel: null,
      aiArtVipLevel: null,
      aiAudioMaxQuotaLevel: null,
      aiAudioVipLevel: null,
      allowUserModifyTimestamp: null,
    },
    configInfo: {
      aiart: {
        pageSize: 5,
      },
      aiaudio: {
        pageSize: 5,
      },
      chatgpt: {
        pageSize: 5,
        enableStream: true,
      },
      log: {
        isOpenLog: true,
      },
      notify: {
        isOpenNotify: false,
        isOpenNotifySound: false,
      },
      theme: {
        themeMode: "light",
      },
      decoration: {
        isOpenLantern: false,
      },
    },
  },
  mutations: {
    login(state, user) {
      state.userId = user.id;
      state.avatar = user.avatar;
      state.nickname = user.nickname;
      state.intro = user.intro;
      state.webSite = user.webSite;
      state.articleLikeSet = user.articleLikeSet ? user.articleLikeSet : [];
      state.commentLikeSet = user.commentLikeSet ? user.commentLikeSet : [];
      state.email = user.email;
      state.token = user.token;
      localStorage.setItem("token", state.token);
      state.loginType = user.loginType;
    },
    logout(state) {
      state.userId = null;
      state.avatar = null;
      state.nickname = null;
      state.intro = null;
      state.token = null;
      localStorage.removeItem("token");
      state.webSite = null;
      state.articleLikeSet = [];
      state.commentLikeSet = [];
      state.email = null;
      state.loginType = null;
    },
    saveLoginUrl(state, url) {
      state.loginUrl = url;
    },
    saveEmail(state, email) {
      state.email = email;
    },
    updateUserInfo(state, user) {
      state.nickname = user.nickname;
      state.intro = user.intro;
      state.webSite = user.webSite;
    },
    savePageInfo(state, pageList) {
      state.pageList = pageList;
    },
    updateAvatar(state, avatar) {
      state.avatar = avatar;
    },
    checkBlogInfo(state, blogInfo) {
      state.blogInfo = blogInfo;
      if (blogInfo.user != null) {
        state.userId = blogInfo.user.id;
        state.avatar = blogInfo.user.avatar;
        state.nickname = blogInfo.user.nickname;
        state.intro = blogInfo.user.intro;
        state.webSite = blogInfo.user.webSite;
        state.articleLikeSet = blogInfo.user.articleLikeSet
          ? user.articleLikeSet
          : [];
        state.commentLikeSet = blogInfo.user.commentLikeSet
          ? user.commentLikeSet
          : [];
        state.email = blogInfo.user.email;
        state.token = blogInfo.user.token;
        localStorage.setItem("token", state.token);
        state.loginType = blogInfo.user.loginType;
      }
    },
    checkSkillInfo(state, skillInfo) {
      if (skillInfo != null) {
        state.skillInfo = skillInfo;
      }
    },
    checkConfigInfo(state, configInfo) {
      if (configInfo != null) {
        state.configInfo = configInfo;
        // console.log(state.configInfo)
      }
    },
    closeModel(state) {
      state.registerFlag = false;
      state.loginFlag = false;
      state.bgSoundFlag = false;
      state.isPlayBgSound = false;
      state.searchFlag = false;
      state.emailFlag = false;
    },
    articleLike(state, articleId) {
      var articleLikeSet = state.articleLikeSet;
      if (articleLikeSet.indexOf(articleId) != -1) {
        articleLikeSet.splice(articleLikeSet.indexOf(articleId), 1);
      } else {
        articleLikeSet.push(articleId);
      }
    },
    commentLike(state, commentId) {
      var commentLikeSet = state.commentLikeSet;
      if (commentLikeSet.indexOf(commentId) != -1) {
        commentLikeSet.splice(commentLikeSet.indexOf(commentId), 1);
      } else {
        commentLikeSet.push(commentId);
      }
    },
    setDialogFormVisible(state) {
      state.dialogFormVisible = !state.dialogFormVisible;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});
